/**
 * OTSDR iOS WebKit Viewport Fix
 * Handles dynamic toolbar (100vh issue) on older iOS versions
 */
(function() {
  'use strict';
  
  // Check if browser supports svh (newer iOS/Safari)
  if (CSS.supports('height', '100svh')) {
    // Browser supports svh, no need for JS fallback
    return;
  }
  
  // Fallback for older iOS: use CSS custom property
  function updateViewportHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
  }
  
  // Update on load
  updateViewportHeight();
  
  // Update on resize and orientation change
  window.addEventListener('resize', updateViewportHeight, { passive: true });
  window.addEventListener('orientationchange', updateViewportHeight);
  
  // Add fallback CSS via JS (only if needed)
  const style = document.createElement('style');
  style.textContent = `
    @supports not (height: 100svh) {
      .otsdr-password-hero,
      .otsdr-drop-hero {
        min-height: calc(var(--vh, 1vh) * 100) !important;
      }
    }
  `;
  document.head.appendChild(style);
})();
